import React from 'react';
import {SvgIcon} from '@material-ui/core';

const Cercanias = (props) => <SvgIcon viewBox="138 138 24 24" {...props}>
  <circle cx={149.958} cy={150.042} r={11.958}/>
  <path fill="#FFF" d="M149.958 158.014c-4.396 0-7.972-3.576-7.972-7.972h3.986a3.991 3.991 0 003.986 3.986 3.99 3.99 0 003.985-3.986 3.991 3.991 0 00-3.985-3.987v-3.985c4.396 0 7.974 3.576 7.974 7.972 0 4.396-3.577 7.972-7.974 7.972z"/>
</SvgIcon>;

export default Cercanias;